import { useEffect } from 'react';

import { LOGIN_PAGE_PATH } from 'application/consts';
import { matchPath, useLocation, useNavigate } from 'application/providers/RouterProvider';

const useRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isRoot = matchPath({ path: '/', end: true }, location.pathname);

    if (isRoot) {
      navigate(LOGIN_PAGE_PATH, { replace: true });
    }
  }, [navigate, location.pathname]);
};

export default useRedirect;
